import getApiClient from '@/plugins/api'
import updateNavigationRoutes from "../../../../containers/_nav";

export default {
    setGender: function(gender) {
        this.user.gender = gender
    },

    validationToken() {
        const self = this,
            api = getApiClient(self.$store),
            token = self.$route.params.token

        api.get(`/user/token/${token}/validate`)
            .then(function(response) {
                if(response.data.valid) {
                    self.showForm = true;
                    self.user.name = response.data.name;
                    self.user.email = response.data.email;
                    self.user.rg = response.data.rg ?? null;
                    self.idUser = response.data.id;
                    return;
                }

                self.$router.push('/pages/login')
            })
            .catch(function(error) {
                self.$router.push('/pages/login')
            })
    },

    submitForm() {
        const self = this,
            api = getApiClient(self.$store),
            token = self.$route.params.token,
            cartToken = self.$route.params.cartToken;

        self.errorCode = null;
        self.errorMessage = null;

        if (!self.validateForm()) {
            return;
        }

        let registerData = Object.assign({}, self.user);

        if (registerData.birthDate) {
            registerData.birthDate = registerData.birthDate.split('/').reverse().join('-');
        }

        if (registerData.phone) {
            registerData.phone = registerData.phone.replace(/[^0-9]+/g, '');
        }

        if (registerData.contactPhone) {
            registerData.contactPhone = registerData.contactPhone.replace(/[^0-9]+/g, '');
        }

        if (registerData.rg) {
            registerData.rg = registerData.rg.replace(/[^0-9]+/g, '');
        }

        self.$store.commit('startLoading');

        api.patch(`/user/update/${self.idUser}`, registerData, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(function(response) {
                api.post('/login', {
                    username: self.user.email,
                    password: self.user.password
                })
                  .then(function(response) {
                      self.$store.commit('setJwtToken', response.data.token)

                      self.$cookie.set('token', response.data.token, {
                          expires: 30,
                          domain: 'voudetrip.com.br'
                      });

                      api.get('/user/check_session').then(function(response) {
                          let userId = response.data.id

                          api.get(`/user/${userId}`).then(function(user) {
                              self.$store.commit('setUser', user.data)
                              self.$router.push({
                                  name: 'Complete cart',
                                  params: {
                                      id: cartToken
                                  }
                              })
                          })
                      })
                  })
            })
            .catch(function(error) {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        self.errorCode = 400;
                        self.errorMessage = self.serverError;
                        break;
                    default:
                        self.errorCode = 500;
                        self.errorMessage = self.serverError;
                        break;
                }
            })
            .finally(function() {
                self.$store.commit('stopLoading');
            });
    },

    validateForm() {
        let countError = 0;

        Object.keys(this.error).map((value, index) => {
            countError += this.validateInput(value) ? 1 : 0;
        });

        return countError === 0;
    },

    validateInput(value) {
        this.error[value] = null;

        if (
            this.user[value] === '' ||
            this.user[value] === null ||
            this.user[value] === undefined
        ) {
            this.error[value] = `Este campo é obrigatório.`;
        }

        return this.error[value] ? true : false;
    },

    goRedirect: function() {
        window.location.href = `https://voudetrip.com.br`
    }
}
